import { render, staticRenderFns } from "./MallNoticePopup.vue?vue&type=template&id=208dea56&scoped=true&"
import script from "./MallNoticePopup.vue?vue&type=script&lang=ts&"
export * from "./MallNoticePopup.vue?vue&type=script&lang=ts&"
import style0 from "./MallNoticePopup.vue?vue&type=style&index=0&id=208dea56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208dea56",
  null
  
)

export default component.exports